/* eslint-disable react/jsx-pascal-case */
// import logo from './logo.svg';

//import React, { useContext, useState } from 'react';
//import { VarContext } from './Context/VarContext';

//BrowserRouter: -- puedes usar la barra de direccion para ir a los componentes
//MemoryRouter: -- solo sirven los botones generados en reacj para moverte entre componentes
//HashRouter: -- es un tipo de router de React que usa el hash (#) en la URL para manejar la navegación.


//Router /	URL /	Navegación Manual /	Servidor
//BrowserRouter	/dashboard	✅ Funciona	⚠️ Necesita configuración
//HashRouter	/#/dashboard	✅ Funciona	✅ No necesita configuración
//MemoryRouter	No cambia URL	❌ Solo botones React	✅ No afecta servidor

import {Routes, Route, MemoryRouter } from "react-router-dom";

import { CustomVarContext } from './Context/CustomVarContext';

import { ToastContainer } from './Components/Toast';

import './App.css';
//import ProtectedRoute from './Components/ProtectedRoute';

import Login from './Secciones/Login';
import Introduccion from "./Secciones/Introduccion";
import Dashboard from "./Secciones/Dashboard";
import ResetPassword from './Secciones/ResetPassword';
/*import Perfil from "./Secciones/Perfil";
 import Instrucciones from "./Secciones/Instrucciones";
import Primer_reto from "./Secciones/Primer_reto";
import Quiz1 from "./Secciones/Quiz1";
import Segundo_reto from "./Secciones/Segundo_reto";
import Quiz2 from "./Secciones/Quiz2";
import Tercer_reto from "./Secciones/Tercer_reto";
import Quiz3 from "./Secciones/Quiz3";
import Retro_final from "./Secciones/Retro_final";
import RankingBoard from "./Secciones/RankingBoard"; */
import Admin from "./Secciones/Admin";
import NotFound from './Secciones/NotFound'; // Crea este componente para el 404
import ScormViewer from './Secciones/ScormViewer';

function App() {

  //const GConText = useContext(VarContext);

  return (

    <>
      {/* <Authenticator /> */}

      {/* <Authenticator
          // formFields={formFields}
          // components={components}

          //oculta el crear una cuenta
          hideSignUp={true}
    >
        {({ signOut, user }) => (
          <main>
            <h1>Hello {user.username}</h1>
            <button onClick={signOut}>Sign out</button>
          </main>
        )}
      </Authenticator> */}

      <CustomVarContext>
        <MemoryRouter basename="/" >
          {/* <BrowserRouter basename="/cursos_elearning/oxxo/aguile" > */}
          {/* <BrowserRouter basename="/" > */}
          <div className="App">

            <Routes>
              <Route exact path="/" element={<Login />} />
              <Route path="reset-password" element={<ResetPassword />} />

              <Route path="introduccion" element={<Introduccion />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="admin" element={<Admin />} />
              <Route path="scorm/:id" element={<ScormViewer />} />

              {/* <Route path="introduccion" element={
                <ProtectedRoute>
                  <Introduccion />
                </ProtectedRoute>
              } />
              <Route path="dashboard" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/analytics" element={
                <ProtectedRoute>
                  <AdminAnalytics />
                </ProtectedRoute>
              } />
              <Route path="admin" element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              } /> */}

              <Route path="*" element={<NotFound />} />
            </Routes>
            <ToastContainer />
          </div>
          {/* </BrowserRouter> */}
        </MemoryRouter>
      </CustomVarContext>
    </>
  );
}


//export default withAuthenticator(App);
export default App;
